import * as React from 'react';
import * as styles from './MortgageCalculator.css';

interface IMortgageCalculatorProps {
  propertyCost: React.ReactNode;
  downPayment: React.ReactNode;
  downPaymentLabels: React.ReactNode;
  creditTerm: React.ReactNode;
  creditTermLabels: React.ReactNode;
  summary: React.ReactNode;
  callback: React.ReactNode;
}

export function MortgageCalculator({
  propertyCost,
  downPayment,
  downPaymentLabels,
  creditTerm,
  creditTermLabels,
  summary,
  callback,
}: IMortgageCalculatorProps) {
  return (
    <article data-testid="mortgage-calculator" className={styles['container']}>
      <div className={styles['side']}>
        {propertyCost}

        <div data-testid="down-payment-block" className={styles['slider-item']}>
          {downPayment}
          {downPaymentLabels}
        </div>

        <div data-testid="credit-term-block" className={styles['slider-item']}>
          {creditTerm}
          {creditTermLabels}
        </div>
      </div>

      <div className={styles['side']}>
        {summary}
        <div className={styles['callback']}>{callback}</div>
      </div>
    </article>
  );
}
